import { render, staticRenderFns } from "./nav-title.vue?vue&type=template&id=644611fc&scoped=true&"
import script from "./nav-title.vue?vue&type=script&lang=js&"
export * from "./nav-title.vue?vue&type=script&lang=js&"
import style0 from "./nav-title.vue?vue&type=style&index=0&id=644611fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644611fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('644611fc', component.options)
    } else {
      api.reload('644611fc', component.options)
    }
    module.hot.accept("./nav-title.vue?vue&type=template&id=644611fc&scoped=true&", function () {
      api.rerender('644611fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/nav-title.vue"
export default component.exports